/* eslint-disable import/no-anonymous-default-export */
export default [
    { value: false, label: "approver", id: 2 },
    { value: false, label: "expat officer", id: 3 },
    { value: false, label: "expat in charge", id: 4 }
]
